/* ----------------------------------------------------------------------------------------------------------------
   BUY NOW
   ----------------------------------------------------------------------------------------------------------------

   Botón de compra directa de las landings de anuncios (ver la lista en snippets/buy-buttons.liquid).

   POR QUÉ ENVÍA EL FORMULARIO Y NO USA UN PERMALINK:
   la versión original era un link a /cart/<variante>:<cantidad>?checkout. Un permalink transporta únicamente
   variante y cantidad, y eso alcanzaba mientras la página no tuviera nada más que decir. Dejó de alcanzar cuando
   se instaló una app de descuentos por tramos: la app inyecta tres propiedades de línea en el formulario
   (properties[__essential_upsell_*]) y son esas propiedades las que marcan la línea para que el descuento se
   aplique. El permalink las descartaba, así que al checkout llegaba la cantidad correcta al precio sin descuento.

   Enviar el formulario replica exactamente lo que hace el "Add to cart" del theme (assets/theme.js, ProductForm),
   así que viaja todo lo que la página haya puesto adentro, hoy y en el futuro.

   SI EL ENVÍO FALLA se cae al permalink. Es la razón por la que existía: el autor original lo eligió para
   esquivar un error 400 del formulario que nunca se diagnosticó. Si ese 400 vuelve, el botón sigue vendiendo
   —sin descuento— en vez de romperse, y el error queda en consola para poder mirarlo.
   ---------------------------------------------------------------------------------------------------------------- */

(() => {
  if (window.__vianteBuyNowInit) return;

  window.__vianteBuyNowInit = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // La cantidad puede venir de dos lugares. Con la app de tramos instalada, ella OCULTA el selector del theme e
  // inyecta su propio input[name="quantity"] en el formulario: ese es el único que refleja el tramo elegido, y el
  // del theme se queda congelado en 1. Sin app, el del theme es el único que existe.
  const quantityFor = (link) => {
    const form = document.getElementById(link.dataset.form);
    const inputs = Array.from(document.querySelectorAll('input[name="quantity"]'))
      .filter((input) => input.form === form);
    const injected = inputs.find((input) => !input.closest('.quantity-selector'));
    const input = injected || inputs[0];

    return Math.max(1, parseInt(input && input.value, 10) || 1);
  };

  // Se reescribe solo el tramo de la cantidad sobre el href actual en vez de rearmar la URL desde cero: otras apps
  // le cuelgan parámetros a este mismo link —Intelligems le agrega attributes[igId] para su atribución— y
  // rearmarla se los borraría. La variante también sale del href cuando está, respetando reescrituras ajenas.
  const permalinkFor = (link) => {
    const url = new URL(link.getAttribute('href'), window.location.origin);
    const current = url.pathname.match(/^\/cart\/(\d+):\d+/);

    url.pathname = `/cart/${current ? current[1] : link.dataset.variantId}:${quantityFor(link)}`;

    return url.toString();
  };

  // Los attributes[...] del permalink son atributos DEL CARRITO, no propiedades de línea, así que no viajan en el
  // alta. Se copian aparte para no perder la atribución de Intelligems al dejar de usar el permalink.
  const carryCartAttributes = async (link) => {
    const params = new URL(link.getAttribute('href'), window.location.origin).searchParams;
    const attributes = {};

    params.forEach((value, key) => {
      const match = key.match(/^attributes\[(.+)\]$/);

      if (match) attributes[match[1]] = value;
    });

    if (!Object.keys(attributes).length) return;

    await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    });
  };

  const buyNow = async (link) => {
    const form = document.getElementById(link.dataset.form);

    if (!form) {
      window.location.href = permalinkFor(link);
      return;
    }

    const data = new FormData(form);

    // set() colapsa los duplicados: con la app activa hay dos inputs llamados "quantity" y solo uno está al día.
    data.set('quantity', quantityFor(link));

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error(`cart/add.js respondió ${response.status}: ${await response.text()}`);

      await carryCartAttributes(link);

      window.location.href = `${root}checkout`;
    } catch (error) {
      console.warn('[buy-now] falló el alta al carrito, se cae al permalink sin descuento', error);
      window.location.href = permalinkFor(link);
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-buy-now]');

    if (!link) return;

    event.preventDefault();
    buyNow(link);
  });

  // El href se mantiene al día para que abrir en pestaña nueva y el respaldo sigan siendo correctos.
  const refresh = () => {
    document.querySelectorAll('[data-buy-now]').forEach((link) => {
      link.setAttribute('href', permalinkFor(link));
    });
  };

  document.addEventListener('variant:change', (event) => {
    if (!event.detail || !event.detail.variant) return;

    document.querySelectorAll('[data-buy-now]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), window.location.origin);

      link.dataset.variantId = event.detail.variant.id;
      url.pathname = `/cart/${event.detail.variant.id}:${quantityFor(link)}`;
      link.setAttribute('href', url.toString());
    });
  });

  document.addEventListener('change', (event) => {
    if (event.target.closest('.quantity-selector')) refresh();
  });
})();
